import React, { useState } from 'react';
import classnames from 'classnames';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath } from '@nutastic/nutastic-react-app';
import moveIntoView from '../utils/moveIntoView';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

const Header = () => {
    const componentClass = 'header';
    const scrollThreshold = 650;
    const [hasPastScrollThreshold, setHasPastScrollThreshold] = useState(false);
    const classes = classnames(componentClass, {
        [`${componentClass}--pastTheFold`]: hasPastScrollThreshold
    });

    useScrollPosition(({ prevPos, currPos }) => {
        const { y = 0 } = currPos;
        if (y < -scrollThreshold) {
            !hasPastScrollThreshold && setHasPastScrollThreshold(true);
        } else {
            hasPastScrollThreshold && setHasPastScrollThreshold(false);
        }
    }, [hasPastScrollThreshold]);

    return <header className={ classes }>
        <div className="container">
            <ul>
                <li className="animated fadeInLeft"><span onClick={() => moveIntoView('wedding-section')}>The Wedding</span></li>
                <li className="animated fadeInLeft"><span onClick={() => moveIntoView('reservation-section')}>Registry & Hotel</span></li>
                <li className={`${componentClass}__logo animated fadeInDown`}><ReactSVG src={getPublicImagePath('logo.svg')} /></li>
                <li className="animated fadeInRight"><span onClick={() => moveIntoView('gallery-section')}>Our Love</span></li>
                <li className="animated fadeInRight"><span onClick={() => moveIntoView('footer-section')}>Connect</span></li>
            </ul>
        </div>
    </header>;
};

export default Header;
